import { motion } from 'framer-motion';
import type { PlayerChoice } from '../../types/story.types';

interface ChoiceButtonProps {
  choice: PlayerChoice;
  onClick: (choiceId: string) => void;
  index: number;
}

/**
 * ChoiceButton component
 * Displays a single player choice with animations
 */
export function ChoiceButton({ choice, onClick, index }: ChoiceButtonProps) {
  return (
    <motion.button
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1, duration: 0.3 }}
      whileHover={{ scale: 1.02, x: 10 }}
      whileTap={{ scale: 0.98 }}
      onClick={() => onClick(choice.id)}
      className="choice-button w-full text-left px-4 sm:px-6 py-3 sm:py-4 rounded-lg glass-effect border border-primary-400/30 hover:border-primary-400/60 transition-all duration-200 group"
    >
      <div className="flex items-center gap-2 sm:gap-3">
        <span className="choice-arrow text-primary-400 opacity-0 group-hover:opacity-100 transition-opacity text-sm sm:text-base">
          ▶
        </span>
        <span className="choice-text text-white text-sm sm:text-base md:text-lg font-medium">
          {choice.text}
        </span>
      </div>
    </motion.button>
  );
}
